<template>
  <my-select ref="mySelectSearchRef" 
             show-search
             :default-active-first-option="false"
             :show-arrow="false"
             :filter-option="false"
             :not-found-content="null"
             :allowClear="false"
             :params="props.params"
             @search="handleSearch"
             :on-get-form-data="onGetFormData"
  >
    <slot></slot>
  </my-select>
</template>

<script setup>
  import { ref, defineExpose, defineProps, onMounted, watch, nextTick, useAttrs } from 'vue';
  import mySelect from './index.vue';

  const props = defineProps({
    url: {
      type: [Function],
    },
    params: {
      type: [Object],
      default: () => ({})
    },
    show: {
      type: [Boolean],
      default: true,
    },
    onGetFormData: {
      type: [Function],
    },
    hideAutoOptions: {
      type: [Boolean],
      default: false
    },
    autoInit: {
      type: [Boolean],
      default: false
    }
  });

  const mySelectSearchRef = ref();
  const init = (...arg) => mySelectSearchRef.value.init(...arg);

  const attrs = useAttrs();

  let timeout;
  function fetch(value) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => {
      let params = JSON.parse(JSON.stringify(props.params));
      params[attrs.fieldNames?.label || 'label'] = value;
      mySelectSearchRef.value.init(props.url, params);
    }, 500);
  }

  nextTick(() => {
    props.autoInit && fetch();
  })

  /*
  watch(() => props.show, () => {
    nextTick(() => {
      let params = JSON.parse(JSON.stringify(props.params));
      params[attrs.fieldNames?.value || 'value'] = attrs.modelValue;
      mySelectSearchRef.value.init(props.url, params);
    });
  }, { immediate: true });
  */

  watch(() => attrs.modelValue, (value, old) => {
    if (!!value && !old && typeof props.onGetFormData == 'function' && !props.hideAutoOptions) {
      const formData = props.onGetFormData();
      if (formData[attrs.fieldNames?.label || 'label']) {
        const options = [formData];
        mySelectSearchRef.value.setOption(options);
      }
    }
  }, { immediate: true });

  const handleSearch = val => {
    //console.log(val, 'val');
    fetch(val);
  };

  defineExpose({
    init
  });
</script>
